import request from '@/utils/request';
export function login(data) {
  return request({
    // url: process.env.VUE_APP_BASE_API + '/getVerifyToken',
    url: '/getVerifyToken',
    method: 'post',
    data: data
  });
}